<template>
    <div :class="['numbers cricket', disabledInput ? 'disabledInput' : '']">
        <div class="number" v-for="number in numbers2" :key="number" v-html="number" @click.prevent="add(number)"></div>
        <div :class="['number btn-clr', disabledInput ? 'disabled' : '']" @click.prevent="clr()">CLR</div>
        <div :class="['number btn-send', disabledInput ? 'disabled' : '']" @click.prevent="send()">SEND</div>
    </div>
</template>

<script>
    export default {
        props: ['disabledInput', 'numbers'],
        data() {
            return {
                checkWindowOpen: false,
                numbers2: [
                    "20",
                    "D20",
                    "T20",
                    "19",
                    "D19",
                    "T19",
                    "18",
                    "D18",
                    "T18",
                    "17",
                    "D17",
                    "T17",
                    "16",
                    "D16",
                    "T16",
                    "15",
                    "D15",
                    "T15",
                    "BE",
                    "DBE",
                    "0",
                ]
            }
        },
        mounted() {
            window.addEventListener('keyup', (ev) => {
                this.keyboardInput(ev);
            });
        },
        methods: {
            number(index, index2) {
                return this.numbers[(index-1)*3+(index2-1)]
            },
            keyboardInput(ev) {
                //do not allow inputs if input is disabled
                if (this.disabledInput) return;
                if (ev.code == "Backspace") {
                    this.clr();
                    return;
                }
                if (ev.code == "Enter" || ev.code == "NumpadEnter") {
                    this.send();
                    return;
                }
                for (let i = 0; i < 10; i++) {
                    if (ev.code == "Numpad"+i || ev.code=="Digit"+i)
                        this.add(i);
                }
            },
            add(number) {
                this.$emit('add', number);
            },
            clr() {
                this.$emit('clr');
            },
            send() {
                this.$emit('send');
            },
        }
    }
</script>

<style scoped>
    .btn-number {
        width: 95%;
        height: 10vh;
        text-align: center;
        line-height: 10vh;
        font-size: 2.5em;
        background-color: #ddd;
        color: #333;
        font-weight: bold;
        margin: 2vh auto 0;
    }

    .btn-clr {
        width: 100%;
        background-color: red;
        color: #fff;
    }

    .btn-send {
        width: 100%;
        background-color: green;
        color: #fff;
    }

    .btn-check {
         background-color: rgb(107, 107, 107);
         color: #fff;
    }

    .btn-check.btn-check-allowed {
        background-color: green;
        color: #fff;
    }

    .btn-check.btn-check-disabled {
        background-color: rgb(107, 107, 107);
         color: #fff;
    }

    .btn-checkout {
        height: 10vh;
        text-align: center;
        line-height: 1em;
        font-size: 6em;
        font-weight: bold;
        margin-top: 2vh;
    }

    .btn-checkout .smalltext {
        font-size: 0.25em;
        margin-top: -2em;
    }
</style>
